import { render, staticRenderFns } from "./paramBox.vue?vue&type=template&id=2ac6750e&scoped=true&"
import script from "./paramBox.vue?vue&type=script&lang=js&"
export * from "./paramBox.vue?vue&type=script&lang=js&"
import style0 from "./paramBox.vue?vue&type=style&index=0&id=2ac6750e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac6750e",
  null
  
)

export default component.exports